<template>
  <div class="about clearfix">
    <ui-topbar :logs="true"></ui-topbar>
    <ui-center></ui-center>
    <ui-footer></ui-footer>
  </div>
</template>

<script>
import Topbar from '@/components/layout/Topbar.vue';
import Footer from '@/components/layout/Footer.vue';
import Center from '@/components/about/Center.vue';
export default {
  name: 'About',
  components:{
    'ui-footer': Footer,
    'ui-topbar': Topbar,
    'ui-center': Center
  },
  metaInfo: {
    title: '雪帝数字音频', // set a title
    meta: [{             // set meta
      name: 'keyWords',
      content: '雪帝数字音频'
    },
      {
        name: 'description',
        content: '雪帝数字音频'
      }]
  }
}
</script>

<style scoped lang='less'>
.about{
}
@media (max-width: 1200px) {
}
</style>



// WEBPACK FOOTER //
// src/components/about/About.vue